export { default as PatientJourneyDetails } from './PatientJourneyDetails';
